import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Countdown from '../components/Countdown';

// Background slider images (distinct event views)
import Hero1 from '../assets/images/IMG_1053.JPG';
import Hero2 from '../assets/images/IMG_1054.JPG';
import Hero3 from '../assets/images/IMG_1056.JPG';
import Hero4 from '../assets/images/IMG_1057.JPG';
import Hero5 from '../assets/images/IMG_1058.JPG';

// Welcome section image
import AboutImg from '../assets/images/IMG_0780.JPG';

// Distinct Gallery images - mix of main event and school tour
import Gal1 from '../assets/img whatsapp/WhatsApp Image 2026-07-01 at 1.08.54 PM.jpeg';
import Gal2 from '../assets/images/IMG_1421.JPG';
import Gal3 from '../assets/img whatsapp/WhatsApp Image 2026-07-01 at 1.09.00 PM.jpeg';
import Gal4 from '../assets/images/IMG_1425.JPG';
import Gal5 from '../assets/img whatsapp/3rd image to add.jpeg';
import Gal6 from '../assets/images/IMG_0810.JPG';
import FlyerImg from '../assets/new flyers/WhatsApp Image 2026-07-01 at 12.48.08 PM.jpeg';

const heroImages = [Hero1, Hero2, Hero3, Hero4, Hero5];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showFlyer, setShowFlyer] = useState(false);

  useEffect(() => {
    // Slider logic
    const slideInterval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroImages.length);
    }, 5000);

    // Scroll reveal logic
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    
    // Show flyer popup after a tiny delay for smooth entry
    const flyerTimer = setTimeout(() => {
      const hasShown = sessionStorage.getItem('flyerShown');
      if (!hasShown) {
        setShowFlyer(true);
        sessionStorage.setItem('flyerShown', 'true');
      }
    }, 1200);

    return () => {
      clearInterval(slideInterval);
      observer.disconnect();
      clearTimeout(flyerTimer);
    };
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero__bg-slider">
          {heroImages.map((img, index) => (
            <img 
              key={index} 
              src={img} 
              alt={`Event highlight ${index + 1}`} 
              className={index === currentSlide ? 'active' : ''} 
            />
          ))}
        </div>
        <div className="hero__overlay"></div>
        <div className="hero__content">
          <div className="hero__badge">10th October 2026</div>
          <h1 className="hero__title">Rise locally,<br />Lead globally</h1>
          <p className="hero__subtitle" style={{color: '#fff', fontWeight: 600}}>Positioning Cameroonians talents for the world</p>
          <div className="hero__meta" style={{marginTop: 32}}>
            <span>DOUALA, CAMEROON</span>
            <span className="hero__meta-sep">•</span>
            <span>BEST WESTERN PLUS HOTEL</span>
          </div>
          <div className="hero__actions">
            <Link to="/tickets" className="btn btn-red">Get Ticket Now</Link>
            <Link to="/sponsors" className="btn btn-outline-white">Become a Partner</Link>
          </div>
        </div>
      </section>

      {/* COUNTDOWN */}
      <Countdown targetDate="2026-10-10T09:00:00" />



      {/* WELCOME / ABOUT SNIPPET */}
      <section className="welcome-section">
        <div className="container">
          <div className="welcome-grid">
            <div className="welcome-img-wrap reveal">
              <img src={AboutImg} alt="Welcome to LLC 2026" style={{ objectPosition: 'center 10%' }} />
            </div>
            <div className="reveal delay-1">
              <div className="tour-numbers-eyebrow" style={{justifyContent: 'flex-start'}}>
                <span className="tour-numbers-eyebrow-line"></span>
                THE LLC 2026 NATIONAL SUMMIT
              </div>
              <h2 className="tour-numbers-title" style={{textAlign: 'left', marginBottom: 16}}>WHERE SILICON MOUNTAIN MEETS PROFESSIONAL AMBITION</h2>
              <div className="tour-numbers-divider" style={{margin: '0 0 32px 0'}}></div>
              
              <p className="section-body" style={{fontSize: 22, fontStyle: 'italic', fontWeight: 600, color: '#006eb4', borderLeft: '4px solid var(--red)', paddingLeft: 20, margin: '0 0 24px 0', lineHeight: 1.5}}>
                "Cameroon does not lack talent. It lacks the platform that makes that talent visible to the world. We build that platform."
              </p>
              
              <p className="section-body" style={{fontSize: 16, color: '#4b5563', lineHeight: 1.6, marginBottom: 32}}>
                The LinkedIn Local Cameroon 2026 is the national summit — the culmination of the tour. 2,000 delegates, one day, one room, one declaration that Cameroon's talent is ready for the world.
              </p>
              
              <div>
                <Link to="/about" className="btn btn-blue" style={{textTransform: 'uppercase', padding: '14px 32px', fontSize: 14}}>Discover The Story</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AGENDA SECTION */}
      <section className="section section--gray">
        <div className="container">
          <div className="text-center reveal">
            <div className="tour-numbers-eyebrow">
              <span className="tour-numbers-eyebrow-line"></span>
              AGENDA
            </div>
            <h2 className="tour-numbers-title">A FULL DAY OF TRANSFORMATION</h2>
            <div className="tour-numbers-divider"></div>
            <p className="tour-numbers-subtitle" style={{marginBottom: 40}}>Join us for a dynamic program designed to elevate your professional trajectory.</p>
          </div>
          
          <div className="timeline-container reveal delay-1">
            <div className="timeline-line"></div>
            
            {[
              { time: '7:00 AM', event: 'Welcome Networking Breakfast', type: 'networking', desc: 'Kickstart the day with a healthy breakfast and early-morning connections.' },
              { time: '9:00 AM', event: 'International Keynote Address', type: 'keynote', desc: 'Inspirational addresses by world-class leaders on global talent trends.' },
              { time: '11:00 AM', event: 'Panel: Cameroonian Talent Globally', type: 'panel', desc: 'Top executives and visionaries discuss positioning Cameroonian professionals for global success.' },
              { time: '1:00 PM', event: 'Breakout Sessions (3 Parallel Tracks)', type: 'breakout', desc: 'Tailored workshops covering digital tech, entrepreneurship, and career strategies.' },
              { time: '2:30 PM', event: 'LinkedIn Career Clinic (Live)', type: 'clinic', desc: 'Practical profile auditing, professional headshot assistance, and career coaching.' },
              { time: '3:45 PM', event: 'Ambassador Network Launch', type: 'launch', desc: 'Official launch of the LinkedIn Local chapter network across Cameroon.' },
              { time: '4:30 PM', event: 'Awards Ceremony - 10 Categories', type: 'awards', desc: 'Celebrating Cameroon\'s most outstanding professionals and industry leaders.' },
              { time: '6:00 PM', event: 'Gala Evening Dinner', type: 'gala', desc: 'VIP dinner networking session with speakers, partners, and high-profile delegates.' },
            ].map((item, index) => (
              <div 
                key={index} 
                className={`timeline-item ${index % 2 === 0 ? 'timeline-item--left' : ''} reveal`}
                style={{ transitionDelay: `${index * 0.05}s` }}
              >
                <div className={`timeline-badge timeline-badge--${item.type}`}>
                  <span className="timeline-badge-text">{item.time.replace(':00', '').replace(' ', '')}</span>
                </div>
                <div className="timeline-content-wrap">
                  <div className={`timeline-content timeline-content--${item.type}`}>
                    <span className={`timeline-type-tag timeline-type-tag--${item.type}`}>
                      {item.type}
                    </span>
                    <h3 className="timeline-title">{item.event}</h3>
                    <p className="timeline-desc">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ textAlign: 'center', marginTop: 40 }} className="reveal">
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>
              * Schedule details and tracks are subject to final confirmations.
            </p>
          </div>
        </div>
      </section>

      {/* SPEAKERS PREVIEW */}
      <section className="section">
        <div className="container">
          <div className="text-center reveal">
            <div className="eyebrow" style={{justifyContent: 'center'}}>Industry Leaders</div>
            <h2 className="section-title">Meet Our Speakers</h2>
          </div>
          <div className="speakers-grid mt-8 reveal delay-1">
            {[1, 2, 3, 4].map((_, i) => (
              <div key={i} className="speaker-card">
                <div 
                  className="speaker-card__photo-placeholder"
                  style={{
                    height: '280px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, var(--blue-light), #d0e8f7)',
                    color: 'var(--blue)'
                  }}
                >
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div className="speaker-card__info text-center">
                  <h3 className="speaker-card__name">Speaker TBA</h3>
                  <div className="speaker-card__role">Industry Expert</div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12 reveal delay-2">
            <Link to="/speakers" className="btn btn-outline-red">View All Speakers</Link>
          </div>
        </div>
      </section>

      {/* OVERVIEW SECTION */}
      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>
          <div className="text-center mb-12">
            <h2 className="section-title">LinkedIn Local Cameroon Overview</h2>
            <div className="section-body" style={{ textAlign: 'left', marginTop: '24px' }}>
              <p style={{ marginBottom: '16px' }}>LinkedIn Local is a global community-driven meetup hosted by LinkedIn members around the world. It brings together professionals offline to build meaningful relationships, exchange ideas, explore industry trends, and share best practices for leveraging LinkedIn to accelerate career and business growth.</p>
              
              <p style={{ marginBottom: '16px' }}>LinkedIn Local Cameroon 2026 is set to host the largest professional gathering in Cameroon, welcoming over 2,000 professionals from diverse industries.</p>
              
              <p style={{ marginBottom: '16px' }}>This landmark event hosted at Best Western Plus, Soaho Douala Airport Hotel on the 10th of October is designed to turn online connections into real-life relationships bringing together business leaders, thought leaders, entrepreneurs, professionals, students, and career-driven individuals under one roof.</p>
              
              <p style={{ marginBottom: '16px', fontWeight: 'bold', color: 'var(--blue)' }}>Our mission is simple: connect, learn, collaborate, and unlock opportunities.</p>
              
              <p style={{ marginBottom: '16px' }}>Participants will engage in high-value networking, insightful conversations, and practical learning sessions while building authentic connections that go beyond the screen.</p>
              
              <p style={{ marginBottom: '16px' }}>We will host seasoned experts and specialists across various fields to share actionable insights on how to use LinkedIn strategically and effectively.</p>
              
              <h3 style={{ fontFamily: 'Montserrat', fontSize: '18px', marginBottom: '12px', marginTop: '32px' }}>Key focus areas include:</h3>
              <ul style={{ listStyleType: 'none', paddingLeft: 0, marginBottom: '24px' }}>
                <li style={{ marginBottom: '8px' }}>📌 Preparing for a Global Workforce</li>
                <li style={{ marginBottom: '8px' }}>📌 Recruitment & talent acquisition</li>
                <li style={{ marginBottom: '8px' }}>📌 Employer branding</li>
                <li style={{ marginBottom: '8px' }}>📌 Personal branding</li>
                <li style={{ marginBottom: '8px' }}>📌 Social selling & Business Growth</li>
                <li style={{ marginBottom: '8px' }}>📌 LinkedIn advertising & visibility strategies</li>
                <li style={{ marginBottom: '8px' }}>📌 Strategic Networking</li>
                <li style={{ marginBottom: '8px' }}>📌 Access to opportunities, etc</li>
              </ul>
              
              <p style={{ marginBottom: '16px', fontStyle: 'italic', fontWeight: 'bold' }}>The best opportunities are born from genuine, in-person connections.</p>
              
              <p style={{ marginBottom: '16px', fontWeight: 'bold', color: 'var(--red)' }}>Come ready to engage, learn, and network like never before… because your next opportunity could be one conversation away!!!</p>
            </div>
          </div>
        </div>
      </section>

      {/* GALLERY STRIP */}
      <section className="section section--gray" style={{paddingTop: 80}}>
        <div className="container">
          <div className="text-center reveal">
            <h2 className="tour-numbers-title" style={{marginBottom: 16}}>OUR ACTIVITY HIGHLIGHTS</h2>
            <div className="tour-numbers-divider"></div>
          </div>
          <div className="gallery-strip mt-12 reveal delay-1">
            {[Gal1, Gal2, Gal3, Gal4, Gal5, Gal6].map((img, i) => (
              <div key={i} className="gallery-strip__item">
                <img src={img} alt="Gallery" />
                <div className="gallery-strip__overlay"></div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12 reveal delay-2">
            <Link to="/gallery" className="btn btn-red">View Full Gallery</Link>
          </div>
        </div>
      </section>

      {/* SPONSOR CTA BANNER */}
      <section className="sponsor-banner">
        <div className="container reveal">
          <h2 className="section-title section-title--white" style={{borderBottom: 'none'}}>Partner With Us</h2>
          <p className="section-body" style={{color: 'rgba(255,255,255,0.8)', maxWidth: 600, margin: '0 auto 32px'}}>
            Your partnership is an investment in the most dynamic professional market in Central Africa. Connect with 2,000+ professionals, entrepreneurs, and future leaders.
          </p>
          <Link to="/sponsors" className="btn btn-red btn-lg">Become a Sponsor</Link>
        </div>
      </section>

      {/* FLYER POPUP MODAL */}
      {showFlyer && (
        <div className="flyer-modal-overlay" onClick={() => setShowFlyer(false)}>
          <div className="flyer-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="flyer-modal-close" onClick={() => setShowFlyer(false)} aria-label="Close">
              ✕
            </button>
            <div className="flyer-modal-body">
              <img src={FlyerImg} alt="LinkedIn Local Cameroon 2026 Flyer" className="flyer-modal-img" />
              <div className="flyer-modal-footer">
                <Link 
                  to="/tickets" 
                  className="btn btn-red" 
                  style={{ width: '100%', borderRadius: '8px', padding: '12px', textAlign: 'center' }}
                  onClick={() => setShowFlyer(false)}
                >
                  Get Ticket Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
